import { render, staticRenderFns } from "./ConsumablesBlock.vue?vue&type=template&id=44109771&scoped=true&"
import script from "./ConsumablesBlock.vue?vue&type=script&lang=js&"
export * from "./ConsumablesBlock.vue?vue&type=script&lang=js&"
import style0 from "./ConsumablesBlock.vue?vue&type=style&index=0&id=44109771&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44109771",
  null
  
)

export default component.exports